<template>
  <VueTypeaheadBootstrap
    v-model="search"
    @hit="input_value = $event"
    :data="moedas"
    :serializer="(item) => item.text + ' (' + item.simbolo + ')'"
    :placeholder="placeholder"
    :class="[stateClass]"
    :showOnFocus="true"
    :size="size"
  />
</template>

<script>
import VueTypeaheadBootstrap from "vue-typeahead-bootstrap";
import { mapActions } from "vuex";

import {
  formControlMixin,
  props as formControlProps,
} from "bootstrap-vue/src/mixins/form-control";

import {
  formStateMixin,
  props as formStateProps,
} from "bootstrap-vue/src/mixins/form-state";

import { sortKeys } from "bootstrap-vue/src/utils/object";
import { makePropsConfigurable } from "bootstrap-vue/src/utils/props";
import _ from "lodash";

const props = makePropsConfigurable(
  sortKeys({
    ...formStateProps,
    ...formControlProps,
    value: null,
    return_object: false,
    placeholder: {
      type: String,
      default: "Selecione uma moeda",
    },
    size: {
      type: String,
      default: "md",
    },
  })
);

export default {
  components: { VueTypeaheadBootstrap },
  mixins: [formControlMixin, formStateMixin],
  props,
  data: () => ({
    search: "",
    input_value: null,
    moedas: [],
  }),
  computed: {},
  methods: {
    ...mapActions("moedas", ["ActionToSelect"]),
    setById(id) {
      let selected = _.find(this.moedas, { value: id });
      if (selected) {
        this.search = selected.text + " (" + selected.simbolo + ")";
        this.input_value = selected;
      }
    },
  },
  watch: {
    search: function (value) {
      if (value === "") {
        this.$emit("input", null);
      }
    },
    input_value() {
      if (this.return_object) {
        this.$emit("input", this.input_value);
      } else {
        this.$emit("input", this.input_value.value);
      }
    },
    value: function (value) {
      this.setById(value);
    },
  },
  async created() {
    this.moedas = await this.ActionToSelect();

    if (this.value) {
      this.setById(this.value);
    }
  },
};
</script>

<style lang="scss">
.form-control-custom {
  margin-left: 0;
  padding-left: 0;
  padding-top: 0;

  .form-control {
    border: none !important;
    background: transparent !important;
  }
}
</style>
